module.exports = __webpack_public_path__ + "img/card-layout.b1e5e801.svg";